import React from 'react';
import { FaFacebook, FaLinkedin } from "react-icons/fa";
import { AiFillTwitterCircle } from "react-icons/ai";
import { TiSocialLinkedinCircular } from "react-icons/ti";
const Footer = () => {
    const links = [
        { id: 1, name: "Press", url: "#" },
        { id: 2, name: " Help center", url: "#" },
        { id: 3, name: "Terms and conditions", url: "#" },
        { id: 4, name: "Privacy policy", url: "#" },
        { id: 5, name: "Refund Account Terms & Conditions", url: "#" },
        { id: 6, name: "Cashback Program", url: "#" },
        { id: 7, name: "Security", url: "#" },
        { id: 8, name: "Partner with us", url: "#" },
        { id: 9, name: "How Greatpharma works", url: "#" },
        { id: 10, name: "Careers", url: "#" },
        { id: 11, name: "Download Greatpharma Apps", url: "#" },
        { id: 12, name: "Corporate Customer", url: "#" },
        { id: 13, name: "Request a rider", url: "#" },
    ]
    return (
        <div className='mt-6'>
            <div className="footer-content border-dashed border-t-2 border-b-2">
                <div className="footer-branding-section border-dashed border-b-2 py-8 flex justify-between">
                    <h6 className='text-[#134E47] font-bold'>Great Pharma</h6>
                    <div className="footer-icon-section flex">
                        <FaFacebook className='text-[20px] mt-[2px] mr-2' />
                        <AiFillTwitterCircle className='text-[23px] mt-[1px] mr-2' />
                        <TiSocialLinkedinCircular className='text-[26px]' />
                    </div>
                </div>
                <div className="footer-terms-section grid grid-cols-2 py-8">
                    <div className="flex items-center">
                        <p className='text-[#656565] text-sm'>&copy; {new Date().getFullYear()} Great Pharma</p>
                    </div>
                    <div className="all-contact-links text-end">
                        {
                            links.map((item, i) => <a className='mr-2 text-[#134E47] text-xs' href={item.url} key={i}>{item.name}</a>)
                        }
                    </div>
                </div>
            </div>
            <div className="company-branding-section flex justify-between my-4">
                <p className='text-xs text-[#134E47]'>© {new Date().getFullYear() } Copyright Great Pharma. All Rights Reserved</p>
                {/* <p className='text-xs text-[#134E47]'>Design and Devloped by Zaimah Technologies Ltd.</p> */}
            </div>
        </div>
    );
};

export default Footer;